// extracted by mini-css-extract-plugin
export default {"printerDownload":"PrinterDownload_printerDownload__W5GFK"};